import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useTranslation } from "@bitsentry-ce/i18n";

export function useOnlineStatus() {
  const { t } = useTranslation();
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      if (wasOffline) {
        toast.success(t("common.useOnlineStatus.connectionRestored"), {
          description: t("common.useOnlineStatus.youAreBackOnline"),
        });
        setWasOffline(false);
      }
    };

    const handleOffline = () => {
      setIsOnline(false);
      setWasOffline(true);
      toast.error(t("common.useOnlineStatus.connectionLost"), {
        description: t("common.useOnlineStatus.workingOfflineDescription"),
        duration: Infinity,
      });
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    if (!navigator.onLine) {
      handleOffline();
    }

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [wasOffline, t]);

  return isOnline;
}
